<div class="dialog-header">
    <h2 mat-dialog-title>
        Como funciona a Sincronização
    </h2>
    <div class="header-actions">
        <button mat-icon-button (click)="fechar()" tabindex="-1">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content>
    <div class="info-section pb-2">
        <p>
            A integração da Zoppy mantém o seu programa de relacionamento alimentado com as vendas e os clientes do seu sistema de forma totalmente inteligente e automática. Confiras as regras de como essa sincronização funciona:
        </p>

        <h3>Como a integração funciona?</h3>
        <p>
            As informações do seu sistema são enviadas para a Zoppy automaticamente de <strong>20 em 20 minutos</strong>. Em alguns cenários, dependendo do volume de dados ou da demanda, este envio pode demorar um tempo um pouco maior.
        </p>

        <h3 class="mt-4">O que acontece na primeira vez que eu a ligo?</h3>
        <p>
            Assim que a integração for ativada, ocorre a primeira grande carga de dados. Nós <strong>sincronizamos na mesma hora toda a sua base de cadastros</strong> (clientes, produtos, vendedores e filiais).
            <br>
            Além disso, de forma automática, o sistema buscará e enviará para a nuvem <strong>o histórico de todos os seus pedidos de até 1 ano atrás</strong>. Enviamos os dados retroativos para que a Zoppy tenha volume suficiente para criar uma base de conhecimento e gerar análises ricas de consumo logo no início.
        </p>

        <hr style="margin: 24px 0; border: 0; border-top: 1px solid #e0e0e0; opacity: 0.5;">

        <h3>Quais dados são enviados na integração?</h3>
        <p>
            Para o bom funcionamento do programa de fidelidade na Zoppy, nós lemos do seu sistema (ERP) exatos 5 grupos de informações. Veja abaixo o que é levado de cada um:
        </p>

        <p><strong style="font-size: 16px; color: var(--primary-color);">🏢 1. Lojas (Filiais)</strong><br>
            <i>Cadastro das garantes para que o pedido caia na loja correta.</i> <br/>
            <strong>Enviamos:</strong> Código identificador da loja e o Nome da Empresa.</p>

        <p><strong style="font-size: 16px; color: var(--primary-color);">👤 2. Vendedores</strong><br>
            <i>Garante que, se configurado, as vendas caiam na Zoppy com comissão/metas para o funcionário adequado.</i> <br/>
            <strong>Enviamos:</strong> Nome, E-mail do vendedor e o Telefone de contato.</p>

        <p><strong style="font-size: 16px; color: var(--primary-color);">📦 3. Produtos</strong><br>
            <i>Mantém o catálogo de compras alimentado.</i> <br/>
            <strong>Enviamos:</strong> Código do produto, Descrição (Nome do produto), Preço e o seu Status atual (se está ativo ou inativo).</p>

        <p><strong style="font-size: 16px; color: var(--primary-color);">👥 4. Clientes</strong><br>
            <i>Base vital do sistema para pontuação de seu cliente e envio de réguas de marketing pela zoppy.</i> <br/>
            <strong>Enviamos:</strong> Código do cliente, Nome, E-mail, Data de Nascimento, Telefone de contato e seu Endereço completo (Logradouro, Bairro, Município, UF e CEP).</p>

        <p><strong style="font-size: 16px; color: var(--primary-color);">🛒 5. Pedidos (Vendas)</strong><br>
            <i>Saldos de pontuação e fidelidade.</i> <br/>
            <strong>Enviamos:</strong> Código do faturamento (venda), Vendedor responsável, Loja da venda, Cliente que comprou, Subtotal, Valor dos Descontos aplicados, Frete (se houver), Todos os Produtos levados na compra (item e quantidade) e a Data e Hora em que a venda ocorreu.</p>

        <hr style="margin: 24px 0; border: 0; border-top: 1px solid #e0e0e0; opacity: 0.5;">

        <h3>Regras Importantes sobre as Vendas</h3>
        <p>Existem alguns cirtérios rigorosos antes do seu sistema enviar uma venda para a plataforma da Zoppy:</p>

        <ul class="mb-0">
            <li class="mb-2"><strong>Margem de segurança de 1 hora:</strong> Um pedido de venda só fica disponível para ser enviado à Zoppy <strong>apenas 1 hora após o faturamento</strong> no caixa. Isso garante um tempo limite caso a sua loja cometa algum erro na venda ou necessite cancelar/ajustar a nota antes da Zoppy ver o pedido.</li>
            <li class="mb-2"><strong>Tipos de Vendas:</strong> Apenas os pedidos com natureza de operação <strong>Pré-venda (55)</strong> ou <strong>Checkout (56)</strong>, desde que já tenham sido faturados com sucesso, é que são enviados.</li>
            <li class="mb-2"><strong>Atualização em tempo real do Cliente:</strong> Toda vez que enviamos uma venda garantimos uma conferência prévia. O sistema primeiro confere e <strong>atualiza os dados de cadastro do cliente</strong> daquela venda para, só então, efetivar o pedido na Zoppy.</li>
        </ul>

        <div class="alert alert-warning mt-4 p-3" style="background-color: #fff3cd; color: #856404; font-size: 13.5px; border-radius: 4px; border: 1px solid #ffeeba;">
            <strong style="display: block; margin-bottom: 8px;"><mat-icon style="vertical-align: bottom; font-size: 20px; width: 20px; height: 20px; margin-right: 4px;">warning</mat-icon> Atenção ao Telefone e ao Cadastro na hora da venda</strong>
            <ul style="margin-bottom: 0; padding-left: 20px;">
                <li class="mb-1"><strong>Sem Cliente = Sem Envio:</strong> Se a venda for fechada como Consumidor Final genérico (sem um cliente propriamente cadastrado e vinculado), este pedido <strong>não é enviado</strong> para a Zoppy.</li>
                <li><strong>Telefone Obrigatório:</strong> O telefone é o dado mais importante do cliente para o marketing. Caso o cliente vinculado à venda possua um telefone celular nulo, não preenchido ou inválido (formato estranho), o cliente é recusado. <strong>Por consequência, se o cliente é recusado, as compras e pedidos desse cliente não são enviados.</strong></li>
            </ul>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="pb-3 pr-3">
    <button mat-stroked-button (click)="fechar()">Entendi</button>
</mat-dialog-actions>
